
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"265","height":"73","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.508 16.17L19.134 8 8.878 23.735 7 47.326l20.637 5.45m21.75-36.606l-6.175 25.872v16.34l10.496 4.086 19.756-6.128m0 0l1.852-36.765M73.464 56.34L75.316 72m16.37-1.362l-1.939-28.596 3.473-24.511m3.704 5.447L114.83 25.7l1.234 16.341-19.139 4.766m33.956 23.83l3.087-23.83-3.087-32m-6.791 12.255l20.374-4.085h14.2l3.704 19.064-38.278 10.894m17.287-2.724l29.017 12.937m5.556-48.342l6.174 27.235 1.852 25.873m5.557-50.384l17.286-2.724 17.904 2.043m-17.904 2.723l3.705 40.852 7.408 2.724m14.2-48.342v29.278l2.469 17.702 28.4-7.49m-24.695-12.255l20.991-6.128M237.07 21.616l22.226-4.766","stroke":"#000","stroke-width":"12"}})])
          )
        }
      }
    